module.exports = __webpack_public_path__ + "static/img/slide1.502c9d4.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide1.webp
// module id = TUJd
// module chunks = 1